import { faArrowRightFromBracket } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { ResponseError } from "../apiClient/generated";
import { useLogout } from "../auth";
import { useAccountsApiClient } from "../hooks";
import { ROUTES } from "../routes";

export const IPNotWhitelisted = () => {
    const logout = useLogout();
    // This ugly fix is here to handle the race condition where logout and membership endpoint
    // are called at the same time, and the membership endpoint returns 403 before the logout
    // which causes logout redirecting to loging redirecting back to this page
    const [ipIsBlocked, setIpIsBlocked] = useState(true);
    const apiClient = useAccountsApiClient();

    useEffect(() => {
        apiClient
            .accountsMembershipMyRetrieve()
            // A success means the IP is fine now and the user still has a
            // session, so there is nothing to show them here.
            .then(() => setIpIsBlocked(false))
            .catch((error) => {
                // A network failure has no response to read a status off.
                setIpIsBlocked(
                    error instanceof ResponseError &&
                        error.response.status === 403,
                );
            });
    }, [apiClient]);

    useEffect(() => {
        // Anything other than a block means this page has nothing to say, so
        // send them to the login page to sort the session out.
        if (!ipIsBlocked) {
            window.location.href = ROUTES.LOGIN;
        }
    }, [ipIsBlocked]);

    return (
        <div className="bg-white dark:bg-gray-50">
            <div className="py-12 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
                <div className="mx-auto max-w-screen-sm text-center">
                    <h1 className="mb-4 text-7xl tracking-tight font-extrabold lg:text-9xl text-primary-600 dark:text-primary-500">
                        Ooops!
                    </h1>
                    <p className="mb-4 text-3xl tracking-tight font-bold text-gray-900 md:text-4xl">
                        Your IP is not whitelisted.
                    </p>

                    <p className="mb-4 text-lg font-light text-gray-600">
                        We're sorry for the inconvenience. Your company has
                        provided a range of IP addresses that can be allowed
                        into the system. Your current IP address is not in that
                        range. Please contact your system administrator for more
                        information.
                    </p>
                    <button
                        type="button"
                        onClick={() => logout()}
                        className="
                            flex justify-center items-center
                            w-full md:w-1/2 md:mx-auto px-3 py-1.5
                            rounded-md text-sm font-semibold leading-6 text-white
                            transition-all duration-800 bg-slate-600  shadow-sm hover:bg-indigo-500
                            focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2
                            focus-visible:outline-indigo-600 disabled:bg-gray-700
                        "
                    >
                        <span className="pr-2">Log out</span>
                        <FontAwesomeIcon
                            icon={faArrowRightFromBracket}
                            className="h-4 w-4"
                        />
                    </button>
                </div>
            </div>
        </div>
    );
};
